import { ObjUtils, IEquatable } from "../Utils/ObjUtils";
import { DeviceRef } from "./Refs";
import { DeviceKey } from "./Keys";
import { Device } from "./Device";
import { DeviceSet } from "./DeviceSet";
import { DefaultRefResolver } from "./RefResolver";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";

export class DependentDeviceId implements IEquatable, ObjectSerializer {
	/// <summary>
	/// Device through which the dependent device is discovered and managed
	/// </summary>
	protected _Controller: DeviceRef;

	/// <summary>
	/// Value that uniquely identifies the dependent device within
	/// the context of the controller device
	/// </summary>
	public ControllerLabel: string;

	constructor(controller?: Device, controllerKey?: DeviceKey, controllerLabel?: string) {			
        if (controller) {
            this._Controller = new DeviceRef(controller);
            this.ControllerLabel = controllerLabel;
        }
        else if (controllerKey) {
            this._Controller = new DeviceRef(null, controllerKey);
            this.ControllerLabel = controllerLabel;
        }
        else {
            this._Controller = null;
            this.ControllerLabel = null;
        }
	}

	public get ControllerDeviceRef(): DeviceRef {
		return this._Controller;
	}

	public get ControllerKey(): DeviceKey {
		return this._Controller.DeviceKey; 
	}

	public get ControllerDevice(): Device {
		return this._Controller.Device;
    }

    public get HasControllerDevice(): boolean {
        return (this.ControllerDevice != null);
    }

    public ResolveControllerDevice(deviceSet: DeviceSet): boolean {
        if (!this.HasControllerDevice) {
            this._Controller.Resolve(new DefaultRefResolver(deviceSet));
        }
        return this.HasControllerDevice;
    }

    public Equals(obj: any): boolean {
        if (obj == null)
            return false;

        if (obj == this)
            return true;

        if (!(obj instanceof DependentDeviceId))
            return false;

        var other = <DependentDeviceId>obj;

        if (!ObjUtils.Equals(this.ControllerLabel, other.ControllerLabel))
            return false;

        if (!DeviceKey.IsMatch(this.ControllerKey, other.ControllerKey))
            return false;

        return true;
    }

    public GetHashCode(): number {
        // The controller key is not included in the hash code calculation
        // because device keys for the same device are not stable over time.
        // Therefore, two DependentDeviceId's that are "Equals" may have
        // slightly different controller keys, thus making the controller 
        // keys unusable for hash code calculation.

        return ObjUtils.GetHashCode(this.ControllerLabel);
    }

    public ToString(): string {
        return "Label: " + this.ControllerLabel + ", Controller-Key: " + this.ControllerKey.ToString();
	}

	public Write(obj: any, context: any): void {
		obj.dependent_device_id = {};
		obj = obj.dependent_device_id;

		this._Controller.Write(obj, context);
		obj.controller_label = this.ControllerLabel;
	}

	public Read(obj: any, context: any): void {
		if (!obj.dependent_device_id)
			throw new Error();
		obj = obj.dependent_device_id;

		if (obj.device_key !== undefined) {
			this._Controller = new DeviceRef();
			this._Controller.Read(obj, context);
		}

		if (obj.controller_label !== undefined)
			this.ControllerLabel = obj.controller_label;
	}

}
